module.exports = __webpack_public_path__ + "img/appD2.c8f7f587.svg";